import React, { useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BeneficiarioForm from './BeneficiarioForm';

// Alta de un caso de "Beneficiarios sin datos". Admin y coordinador lo
// registran directamente, sin pasar por la Bandeja de aprobación.
const CreatePromocion = () => {
  const navigate = useNavigate();
  const [enviando, setEnviando] = useState(false);
  const [erroresServidor, setErroresServidor] = useState(null);

  const guardar = async (payload) => {
    setEnviando(true);
    setErroresServidor(null);
    try {
      const token = localStorage.getItem('token');
      await axios.post('/promocion', payload, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Registro guardado');
      navigate('/promocion');
    } catch (error) {
      if (error.response?.status === 422) {
        setErroresServidor(error.response.data.errors || { general: [error.response.data.message] });
      } else {
        toast.error('No se pudo guardar el registro');
        console.error('Error guardando beneficiarios sin datos:', error);
      }
    } finally {
      setEnviando(false);
    }
  };

  return (
    <BeneficiarioForm
      titulo="Registrar beneficiarios sin datos"
      onGuardar={guardar}
      enviando={enviando}
      erroresServidor={erroresServidor}
    />
  );
};

export default CreatePromocion;
